import ArticleDate from './ArticleDate';

export default ArticleDate;
